import React from 'react';

import PropTypes from 'prop-types';

import { filtersProptype } from '../../../../../utils/proptypes/charts';
import DashboardWidget from '../DashboardWidget';
import { countChartConfig } from '../DashboardWidget/configs';

const CountChart = ({ chart, onEdit, refresh, filters }) => {
  return (
    <DashboardWidget
      widget={chart}
      onEdit={onEdit}
      refresh={refresh}
      filters={filters}
      config={countChartConfig}
    />
  );
};

CountChart.propTypes = {
  chart: PropTypes.shape({
    queryParams: PropTypes.shape({
      formId: PropTypes.string,
      eventTypes: PropTypes.array,
      secondDimension: PropTypes.string,
    }),
    title: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    layout: PropTypes.object.isRequired,
    aggregations: PropTypes.object.isRequired,
  }).isRequired,
  onEdit: PropTypes.func.isRequired,
  refresh: PropTypes.bool.isRequired,
  filters: filtersProptype.isRequired,
};

export default CountChart;
